import { createSelector } from "reselect";

import { calendarSelectors } from "../definition/calendar";
import { isDateValid } from "../definition/calendar/dateFunctions";
import dateByAddingSpan from "../definition/calendar/dateFunctions/dateByAddingSpan";
import { itemSelectors } from "../items";

let getRangeFrom = state => state.data.timelineRange.from;

let getRangeTo = state => state.data.timelineRange.to;

//#!if harvard === true
getRangeFrom = createSelector(
  itemSelectors.getEarliestTimelineEvent,
  state => state.data.timelineRange.from,
  (earliestEvent, rangeFrom) =>
    isDateValid(rangeFrom)
      ? rangeFrom
      : earliestEvent && isDateValid(earliestEvent.startDate)
        ? earliestEvent.startDate
        : null
);

getRangeTo = createSelector(
  itemSelectors.getLatestTimelineEvent,
  state => state.data.timelineRange.to,
  calendarSelectors.getCalendar,
  (latestEvent, rangeTo, calendar) =>
    isDateValid(rangeTo)
      ? rangeTo
      : latestEvent && isDateValid(latestEvent.startDate)
        ? dateByAddingSpan(calendar, latestEvent.startDate, latestEvent.duration)
        : null
);
//#!endif

export default {
  getRangeFrom,
  getRangeTo
};
